(function() {
  "use strict";
  angular.module("marketPlace.address", []);
})();
